import { createContext } from 'react';

export const ContactContext = createContext();
